module.exports = "<my-app-header></my-app-header>\n<div class=\"wrapper\">\n    <my-app-sidenav></my-app-sidenav>\n    <main class=\"main\">\n        <router-outlet></router-outlet>\n    </main>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = 973
// module chunks = 10